export default "__VITE_ASSET__d6d1be98__"